<script>
	// Partials
	import RuleTags from '@/Partials/User/_RuleTags.svelte';
	import Rewards from '@/Partials/User/_Rewards.svelte';
	import Stats from '@/Partials/User/_Stats.svelte';
	import Notes from '@/Partials/User/_Notes.svelte';
	import Promotions from '@/Partials/User/_Promotions.svelte';
	import RealNetWin from '@/Partials/User/_RealNetWin.svelte';
	import ClientEdge from '@/Partials/User/_ClientEdge.svelte';
	import UserProjections from '@/Partials/User/_UserProjections.svelte';
	// Stores
	import ACLStore from '@/Stores/ACLStore.js';

	export let user;
</script>

<div class="mb-4 mx-2 md:mb-1 md:mx-2 gap-y-4 md:gap-y-0 md:gap-x-2 flex flex-col md:flex-row">
	{#if $ACLStore && ACLStore.granted('users')}
		<Stats {user} />
	{/if}
	{#if $ACLStore && ACLStore.granted('user_notes')}
		<Notes {user} />
	{/if}
</div>
<div class="mb-4 mx-2 md:mb-1 md:mx-2 gap-y-4 md:gap-y-0 md:gap-x-2 flex flex-col md:flex-row">
	{#if $ACLStore && ACLStore.granted('rules.read')}
		<RuleTags {user} />
	{/if}
	{#if $ACLStore && ACLStore.granted('users')}
		<UserProjections {user} />
	{/if}
</div>
<div class="mb-4 mx-2 md:mb-1 md:mx-2 gap-y-4 md:gap-y-0 md:gap-x-2 flex flex-col md:flex-row">
	{#if $ACLStore && ACLStore.granted('package.read')}
		<Rewards {user} />
	{/if}
	{#if $ACLStore && ACLStore.granted('promotions.read')}
		<Promotions {user} />
	{/if}
</div>
<div class="mb-4 mx-2 md:mb-0 md:mx-2 gap-y-4 md:gap-y-0 md:gap-x-2 flex flex-col md:flex-row pb-2 md:pb-1">
	{#if $ACLStore && ACLStore.granted('users')}
		<RealNetWin {user} />
	{/if}
	{#if $ACLStore && ACLStore.granted('users')}
		<ClientEdge {user} />
	{/if}
</div>
